import { useQuery } from "@tanstack/react-query";
import {
  PARTICIPANTS_GET,
  getConversationParticipants,
} from "@/api/client/participant";

export const useConversationParticipants = (
  conversationId: string | undefined,
  enabled = true,
) => {
  return useQuery({
    queryKey: [PARTICIPANTS_GET, conversationId],
    queryFn: () => getConversationParticipants(conversationId!),
    enabled: !!conversationId && enabled,
  });
};
